<template>
    <v-dialog v-bind="$attrs" max-width="1440" content-class="rounded-0" @click:outside="$emit('close')">
        <v-toolbar height="auto">
            <v-spacer></v-spacer>
            <v-btn icon color="grey6" class="transparent" @click.stop="$emit('close')">
                <v-icon size="34">mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card tile elevation="0">
            <div class="py-40 py-md-60 py-lg-80">
                <v-container class="container--small">
                    <slot />
                </v-container>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {
        closeDialog() {
            this.$emit('input', false);
        },
    },
};
</script>

<style lang="scss" scoped></style>
